import { useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { SearchSelect } from "@/components/SearchSelect";
import { AccountFields, CATEGORY_OPTIONS, catLabel, initAccountForm, accountPayload } from "@/components/AccountFields";

const EXPENSE_FIRST = ["Expenses", "Cost of Sales", "Other Expenses"];
const GROUP_ORDER = [...EXPENSE_FIRST, ...CATEGORY_OPTIONS.map((c) => c.v).filter((v) => !EXPENSE_FIRST.includes(v))];

// Searchable account picker with built-in "+ Tambah akun baru" quick-add modal.
export function AccountSelect({ accounts, value, onChange, onAccountCreated, testid, placeholder = "Pilih akun", grouped = true, filter, defaultCategory }) {
  const [quickAdd, setQuickAdd] = useState(null);
  const list = filter ? accounts.filter(filter) : accounts;
  const options = grouped
    ? GROUP_ORDER.flatMap((cat) => list.filter((a) => a.category === cat).map((a) => ({ value: a.code, label: `${a.code} · ${a.name}`, group: catLabel(cat) })))
    : list.map((a) => ({ value: a.code, label: `${a.code} · ${a.name}` }));
  return (
    <>
      <SearchSelect options={options} value={value} onChange={onChange} testid={testid} placeholder={placeholder} grouped={grouped}
        onCreate={(q) => setQuickAdd({ name: q })} createLabel="Tambah akun baru" createTestid={`${testid}-add-new`} />
      {quickAdd && (
        <QuickAddAccount accounts={accounts} initialName={quickAdd.name} defaultCategory={defaultCategory}
          onClose={() => setQuickAdd(null)}
          onSaved={(acc) => { onAccountCreated && onAccountCreated(acc); onChange(acc.code); setQuickAdd(null); }} />
      )}
    </>
  );
}

// Quick-add modal — same fields, options, structure and validation as the full
// "Tambah akun baru" form in Daftar Akun (shared AccountFields component).
export function QuickAddAccount({ accounts, initialName, defaultCategory, onClose, onSaved }) {
  const [form, setForm] = useState(() => ({ ...initAccountForm(null, accounts, defaultCategory || "Expenses"), name: initialName || "" }));
  const [isSub, setIsSub] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const submit = async () => {
    setSaving(true); setError("");
    try { onSaved(await api("/accounts", { method: "POST", body: JSON.stringify(accountPayload(form, isSub)) })); }
    catch (e) { setError(e.message); setSaving(false); }
  };
  return (
    <div className="modal-overlay" data-testid="quick-account-modal" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="form-panel">
          <div className="section-head">
            <div><p className="eyebrow">DAFTAR AKUN</p><h2>Tambah akun baru</h2></div>
            <button data-testid="quick-account-close" className="icon-btn" onClick={onClose}><X size={18} /></button>
          </div>
          {error && <div className="success-message error" data-testid="quick-account-error">{error}<button onClick={() => setError("")}><X size={14} /></button></div>}
          <AccountFields accounts={accounts} form={form} setForm={setForm} isSub={isSub} setIsSub={setIsSub} initial={null} />
          <div className="form-actions acc-actions">
            <button data-testid="quick-account-cancel" className="text-btn" onClick={onClose}>Batalkan</button>
            <button data-testid="quick-account-save" className="primary-btn" disabled={!form.name || !form.code || saving} onClick={submit}>{saving ? "Menyimpan..." : "Simpan"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
